/* eslint-disable */

import React, { useEffect, useState } from 'react';
import $ from 'jquery';
import { useSelector, useDispatch } from "react-redux";
import {
  selectHeadTitle,
  selectUQueryString,
  selectOpenSection,
  selectXRefPath,
} from "../features/counter/counterSlice";
import {
  setOpenModalFlag,
  selectFavourites,
} from '../store/reducers/favourite';
import useTopicFunctions from '../hooks/useTopicFunctions';
import useDebounce from '../hooks/useDebounce';
import useTOC from '../hooks/useTOC';
import { NavLink } from 'react-router-dom';

const AddFavouriteModal = React.lazy(() => import('./addFavouriteModal'));
const ExpertGroupsModal = React.lazy(() => import('./expertGroups'));

const TopicTools = ({ locationSearch }) => {
  const dispatch = useDispatch();
  const headTitle = useSelector(selectHeadTitle);
  const queryString = useSelector(selectUQueryString);
  const openSection = useSelector(selectOpenSection);
  const xRefPath= useSelector(selectXRefPath);
  const favourites = useSelector(selectFavourites);
  const [favourite, setFavourite] = useState('');
  const [section, setSection] = useState('');
  const [addFavModalLoad, setAddFavModalLoad] = useState(false);
  const [isCurrentFave, setIsCurrentFave] = useState(false);
  const [disableSearch, setDisableSearch] = useState(false);
  const [searchValue, setSearchValue] = useState('');
  const [addFavouriteClass, setAddFavouriteClass] = useState('');
  const [disabledFavClass, setDisabledFavClass] = useState('');
  const { useDebounceStateValue } = useDebounce();
  const { useTOCState } = useTOC();
  const {
    printTopic,
    toggleFontSize,
    search,
    searchWithinPage,
    getOpenSection,
    processFavourite,
  } = useTopicFunctions();

  const { toc } = useTOCState(locationSearch);

  const debouncedSearchValue = useDebounceStateValue(searchValue, 500);

  useEffect(() => {
    if (debouncedSearchValue) {
      search(debouncedSearchValue);
    }
  }, [debouncedSearchValue])

  useEffect(() => {
    setAddFavouriteClass('');
    setIsCurrentFave(false);

    if (!headTitle) {
      setDisabledFavClass('disabled');
      setDisableSearch(true);
      return;
    } else {
      setDisabledFavClass('');
      setDisableSearch(false);
      if (favourites) {
        if (headTitle) {
          if (favourites[headTitle.toLowerCase().replace(/\s/g,'')]) {
            setAddFavouriteClass('savedTopic');
            setIsCurrentFave(true);
          } else {
            setAddFavouriteClass('');
            setIsCurrentFave(false);
          }
        // } else if (xRefPath) {
        //   const favourite = processFavourite(xRefPath);
        //   if (favourites[favourite.toLowerCase().replace(/\s/g,'')]) {
        //     setAddFavouriteClass('savedTopic');
        //     setIsCurrentFave(true);
        //   } else {
        //     setAddFavouriteClass('');
        //     setIsCurrentFave(false);
        //   }
        } else {
          setAddFavouriteClass('');
          setIsCurrentFave(false);
        }
      }
    }
  }, [headTitle, queryString, xRefPath, favourites]);

  const addFavourite = () => {
    if (headTitle) {
      setFavourite(headTitle);
      const os = getOpenSection(openSection, xRefPath);
      setSection(os);
    } else {
      const favourite = processFavourite(xRefPath);
      setFavourite(favourite);
    }

    setAddFavModalLoad(true);
    $('.popover').show();
  }

  const closeAddFavorite = () => {
    $('.popover').hide();
  }

  const openModal = () => {
    dispatch(setOpenModalFlag(true));
  }

  return (
    <div className="topic-tools" style={{ 'marginTop': '-5px' }}>
      <div className="container">
        <div className="row col-xs-12 col-sm-6 col-md-9">
          <ul className="topic-icons showIcon topicButtons">
            <li>
              <NavLink to="#expertgroup" className="expertgroup" data-tooltip="true" data-toggle="modal" data-placement="bottom" data-target="#expertgroup" title="Expert Group" data-original-title="Expert Group" onClick={(e) => {e.preventDefault()}}></NavLink>
              <ExpertGroupsModal />
            </li>
            <li className="printMobile" style={{ 'paddingLeft': '7px' }}>
              <NavLink to="#" className="print" data-tooltip="true" data-placement="bottom" title="Print Topic" data-original-title="Print topic" onClick={printTopic}></NavLink>
            </li>
            <li style={{ 'paddingLeft': '7px' }}>
              <a className={`topicFavourite ${addFavouriteClass} ${disabledFavClass}`} id="Bartonellainfections" data-tooltip="true" data-placement="bottom" data-contentwrapper=".myfavourite" title="Add To Favourites" data-original-title="Add to favourites" onClick={() => addFavourite(headTitle)}></a>
              <AddFavouriteModal
                isCurrentFave={isCurrentFave}
                openModal={openModal}
                shouldLoad={addFavModalLoad}
                setShouldLoad={setAddFavModalLoad}
                favourite={favourite}
                toc={toc}
                section={section}
                setFavourite={setFavourite}
                closeAddFavorite={closeAddFavorite}
                setAddFavouriteClass={setAddFavouriteClass}
              />
            </li>
            <li style={{ 'paddingLeft': '7px' }}>
              <NavLink to="#" className="togglefontsize toggleFontSize" data-tooltip="true" data-placement="bottom" title="Toggle Font Size" data-original-title="Toggle Font Size" onClick={toggleFontSize}></NavLink>
            </li>
          </ul>
        </div>
        <div className="searchWithinPage col-xs-12 col-sm-6 col-md-3 col-lg-2 noRightPadding pull-right">
          <div className="input-group topicSearch col-xs-12">
            <div className="form-group">
              <input type="text" value={searchValue} id="searcher" className="form-control input-sm" placeholder="Search within page" style={{ 'border': '0' }} onChange={(e) => setSearchValue(e.target.value)} disabled={disableSearch} />
            </div>
            <span className="input-group-btn" style={{ 'background': '#fff' }}>
              <a className={`btn-search nopadding ${disabledFavClass}`} onClick={() => searchWithinPage()} type="button">
                <span className="flaticon-magnifying-glass34"></span>
              </a>
            </span>
          </div>
        </div>
      </div>
    </div>
  )
}

export default TopicTools;
